import React, { ReactNode } from 'react'
import * as styles from './Badge.module.scss'

interface BadgeProps {
  children: ReactNode
  className?: string
  style?: React.CSSProperties
}
const Badge: React.FC<BadgeProps> = ({ children, className, style }: BadgeProps) => {
  return (
    <div
      className={className}
      style={style}
    >
      <div className={`${styles.badge}`}>
        {children}
      </div>
    </div>
  )
}

export default Badge
